import { general_service } from '../const';
import { generateSignature } from '$lib/utils/Signature';
export const trailingSlash = 'always';
export const prerender = true;
export const ssr = true;
export const load = async () => {
	const signature = await generateSignature();
	const url = general_service + 'producers';
	const request = await fetch(url, { headers: signature });
	const data = await request.json();

	return {
		producers: data
	};
};
